import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { Tank } from 'src/app/shared/models/Tank';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'voucher-filter',
  templateUrl: './voucher-filter.component.html',
  styleUrls: ['./voucher-filter.component.css']
})
export class VoucherFilterComponent implements OnInit {

  @Output() filterApplied = new EventEmitter<any>();

  currentTank: Tank;
  users: User[];
  dateFrom;
  dateTo;
  status;
  selectedStatus = null;
  selectedUser = null;

  filter = {
    dateFrom: null,
    dateTo: null,
    user: null,
    status: null
  };

  voucherStatus: string[] = ['EXPIRED', 'CANCELED', 'FINISHED', 'PENDING', 'ACTIVE'];

  constructor(private tankService: TankService, private userService: UserService) { }


  ngOnInit() {



    this.tankService.getCurrentTank().subscribe((tank) => {
      this.currentTank = tank;
      console.log('tanque: ', tank);
      // Después de obtener el tanque, obtenemos la lista de usuarios.
      this.listUsers();
    });
  }

  listUsers() {
    this.userService.getUsersByTank(this.currentTank.id).subscribe(
      (users) => {
        this.users = users;
      }, (error) => {
        console.log(error);
      }
    );

  }

  applyFilter() {
    if (this.dateFrom) {
      this.filter.dateFrom = new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day);
    } else { this.filter.dateFrom = null; }
    if (this.dateTo) {
      this.filter.dateTo = new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day);
    } else { this.filter.dateTo = null; }
    this.filter.user = this.selectedUser;
    this.filter.status = this.selectedStatus ? this.selectedStatus : null;

    this.filterApplied.emit(this.filter);
  }

}
